/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RestoreResourceResponse
 */
export interface RestoreResourceResponse {
	/**
	 * RID of the resource
	 * @type {string}
	 * @memberof RestoreResourceResponse
	 */
	rID: string;
	/**
	 * State information of the resource
	 * @type {object}
	 * @memberof RestoreResourceResponse
	 */
	state: object;
}

/**
 * Check if a given object implements the RestoreResourceResponse interface.
 */
export function instanceOfRestoreResourceResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'state' in value;

	return isInstance;
}

export function RestoreResourceResponseFromJSON(json: any): RestoreResourceResponse {
	return RestoreResourceResponseFromJSONTyped(json, false);
}

export function RestoreResourceResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): RestoreResourceResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		state: json['state'],
	};
}

export function RestoreResourceResponseToJSON(
	value?: RestoreResourceResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		state: value.state,
	};
}
